import { useEffect, useRef } from 'react';
import { usePlaybackStore } from '../store/usePlaybackStore';

/**
 * Advances `playheadMs` while `isPlaying` is true (requestAnimationFrame, wall-clock × playbackRate).
 * Mount once under `SessionViewer` / `SessionViewerApp`.
 */
export function PlaybackClock() {
  const isPlaying = usePlaybackStore((s) => s.isPlaying);
  const playbackRate = usePlaybackStore((s) => s.playbackRate);
  const lastWallRef = useRef(0);
  const rafRef = useRef(0);

  useEffect(() => {
    if (!isPlaying) {
      lastWallRef.current = 0;
      return;
    }

    lastWallRef.current = performance.now();

    const tick = (now: number) => {
      const st = usePlaybackStore.getState();
      if (!st.isPlaying) return;
      const prev = lastWallRef.current || now;
      lastWallRef.current = now;
      const wallDt = now - prev;
      st.advancePlayheadWallMs(wallDt);
      rafRef.current = requestAnimationFrame(tick);
    };

    rafRef.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafRef.current);
  }, [isPlaying, playbackRate]);

  return null;
}
